import { useEffect, useState } from "react";
import s from "./QuizLoader.module.scss";

const QuizLoader = ({ totalDuration }) => {
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    const intervalDuration = totalDuration / 100;
    const timer = setInterval(() => {
      setPercent((prevPercent) => {
        const newPercent = prevPercent + 1;
        if (newPercent >= 100) {
          clearInterval(timer);
          return 100;
        }
        return newPercent;
      });
    }, intervalDuration);

    return () => clearInterval(timer);
  }, [totalDuration]);

  return (
    <div className={s["loader-container"]}>
      <div className={s["loader-bar"]}>
        <div className={s["filler"]} style={{ width: `${percent}%` }}></div>
      </div>
    </div>
  );
};

export default QuizLoader;
